<template>
	<div :class="{ 'url-card': true, maxheight: isUrlCard }">
		<a
			v-if="isUrlCard"
			:href="safeHref"
			target="_blank"
			:class="{ 'attachment-link': true, disabled }"
			@click="onUnfurlCardClick"
			data-private
		>
			<div
				ref="urlCard"
				:class="{
					'unfurl-card-horz pointer': true,
					'p-l-10': applyImagePadding,
				}"
			>
				<img
					v-if="hasThumbnail"
					class="thumbnail-img ph-no-capture"
					:src="resource.thumbnailurl"
					alt=""
				/>
				<div id="unfurlHorzCardDetails">
					<div class="unfurl-providername" v-text="url" />
					<div class="unfurl-title line-clamp-1">
						{{ resource.title }}
					</div>
					<div
						v-if="resource.snippet"
						class="unfurl-snippet line-clamp-2"
						v-text="resource.snippet"
					/>
				</div>
			</div>
		</a>
		<a
			v-if="isMediaCard"
			:href="safeHref"
			target="_blank"
			class="attachment-link"
			data-private
		>
			<div class="unfurl-card-vert pointer">
				<div id="unfurlVertCardDetails">
					<div class="unfurl-providername line-clamp-1" v-text="url" />
				</div>
				<img :src="resource.thumbnailurl" alt="" class="ph-no-capture" />
			</div>
		</a>
	</div>
</template>
<script>
import { getInviteCodeFromUrl } from '@/components/Invite'
import { inMeeting } from '@/helperMethods'
import { safeUrl } from '@/helpers/utils'

const parseUrl = (url) => {
	if (typeof url !== 'string' || !url) return ''
	if (!/^https?:\/\//i.test(url)) {
		url = 'http://' + url
	}
	try {
		return new URL(url).host.replace(/www./gi, '')
	} catch {
		// a hostile or malformed resource.url must not break the card render
		return ''
	}
}

export default {
	name: 'UnfurlCard',
	props: ['resource', 'disabled'],
	data() {
		return { applyImagePadding: false }
	},
	methods: {
		onUnfurlCardClick(e) {
			const inviteCode = getInviteCodeFromUrl(this.resource.url)
			if (inviteCode && !inMeeting()) {
				e.preventDefault()
				EventBus.$emit('openGroupInviteLink', inviteCode)
			}
		},
	},
	computed: {
		safeHref() {
			return safeUrl(this.resource.url)
		},
		isUrlCard() {
			return this.resource.title
		},
		isMediaCard() {
			return !this.resource.title && this.resource.thumbnailurl
		},
		url() {
			return parseUrl(this.resource.url)
		},
		hasThumbnail() {
			return (
				this.resource.thumbnailurl &&
				this.resource.thumbnailheight > 0 &&
				this.resource.thumbnailwidth > 0
			)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.url-card {
	margin: 4px 0;
}

.attachment-link {
	&.disabled {
		pointer-events: none;
	}
}

.unfurl-card {
	border: solid 1px var(--neutral-200);
	@include radius;
	background: var(--neutral-0);
	width: 343px;
	height: 492px;
	font-family: Avenir-Roman;
	a {
		text-decoration: none;
	}
	img {
		object-fit: contain;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
	}
}

.unfurl-card > #unfurlCardDetails {
	padding: 10px;
}

.unfurl-card-horz {
	border: solid 1px var(--neutral-200);
	@include radius;
	max-width: 800px;
	max-height: 140px;
	overflow: auto;
	position: relative;
	float: left;
	overflow: hidden;
	background: var(--neutral-0);
	display: flex;
	align-items: center;
	img {
		max-height: 140px;
		max-width: 200px;
	}
}

.unfurl-card-vert {
	border: solid 1px var(--neutral-200);
	border-radius: 8px;
	max-width: 300px;
	max-height: 400px;
	overflow: hidden;
	img {
		vertical-align: bottom;
		max-height: 365px;
		max-width: 300px;
	}
}

#unfurlHorzCardDetails {
	padding: 10px 20px 10px 10px;
}
#unfurlHorzCardDetails .unfurl-providername {
	margin-bottom: 3px;
}

#unfurlVertCardDetails {
	padding: 10px;
}

#unfurlHorzCardDetails {
	display: inline-block;
}

.unfurl-title {
	color: var(--blue-300);
	font-size: 14px;
	font-family: Avenir-Heavy;
	font-weight: normal;
	position: relative;
	margin-bottom: 4px;
	overflow: hidden;
	position: relative;
	line-height: 1.4em;
	max-height: 4.2em;
	margin-right: -1em;
	padding-right: 1em;
}

.unfurl-snippet {
	color: var(--neutral-800);
	font-size: 14px;
	font-family: Avenir-Roman;
	font-weight: normal;
	position: relative;
	margin-bottom: 4px;
	overflow: hidden;
	position: relative;
	line-height: 1.4em;
	max-height: 2.8em;
	margin-right: -1em;
	padding-right: 1em;
}

.unfurl-providername {
	font-family: Avenir-Heavy;
	font-size: 10px;
	color: var(--neutral-500);
}

.maxheight {
	max-height: 140px;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.unfurl-card,
	.unfurl-card-horz {
		img {
			// https://css-tricks.com/a-complete-guide-to-dark-mode-on-the-web/#aa-dark-mode-images
			filter: brightness(0.8) contrast(1.2);
		}
	}
}
</style>
